export default "__VITE_ASSET__nyVKiFo5__"